import { useState, useContext } from "react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import IconPencilEdit from "../../../assets/svg/pencil-square.svg";
import IconClose from "../../../assets/svg/x.svg";
import style from "../calculator.module.css";
import { Context } from "../../../App";
function EditableMarket(props) {
  const { statusMode } = useContext(Context);
  const { operation, index, updateField, startCalcFormulaLay, dataOperation, handleCheckboxChangeMarketType } = props;
  const [isEditing, setIsEditing] = useState(false);
  const toggleEdit = () => {
    setIsEditing(!isEditing);
  };
  const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            {isEditing ? "Fechar Edição de Mercado" : "Editar Mercado"}
        </Tooltip>
  );

  const checked = operation.market_event.trim().toLowerCase().includes("lay (contra)");
  return (
        <div className="w-50 d-flex flex-column justify-content-center my-3 px-2" key={index}>
            <div className='d-flex justify-content-between align-items-center'>

                <abbr
                    title={operation.info_market_event}
                    className="cursor-help"
                    data-bs-delay='{"show":150,"hide":0}'
                    data-bs-html="false"
                    data-bs-original-title={operation.info_market_event}
                    data-bs-toggle="tooltip"
                    data-bs-trigger="hover"
                >
                    {operation.market_event}
                </abbr>

                <div className='d-flex align-items-center'>
                    <OverlayTrigger placement="top" overlay={renderTooltip}>
                        <div>
                            <input
                                type="checkbox"
                                className="form-check-input me-1 fs-5"
                                checked={checked}
                                onChange={() => handleCheckboxChangeMarketType(index)}
                            />
                            <button
                                type="button"
                                className={`btn ${isEditing ? "btn-danger" : "btn-primary"}`}
                                onClick={toggleEdit}
                            >
                                {isEditing ?
                                    <img src={IconClose} alt="Pencil Edit" />
                                    :
                                    <img src={IconPencilEdit} alt="Pencil Edit" />
                                }
                            </button>
                        </div>
                    </OverlayTrigger>
                </div>
            </div>





            {isEditing && (
                <div className='grid flex-column market-settings'>
                    <input
                        type="text"
                        value={operation.market_event}
                        onChange={(e) => {
                            let newMarket = e.target.value;
                            const updated = [...dataOperation];
                            updated[index].market_event = newMarket;
                            startCalcFormulaLay(updated);
                        }}
                        className={`mb-1 align-self-center form-control ${statusMode ? `${style.calculator_border_color_dark} ${style.calculator_text_dark_mode} ${style.calculator_bg_dark}` : ""}`}
                    />

                    <input
                        type="text"
                        value={operation.info_market_event}
                        onChange={(e) => updateField(index, "info_market_event", e.target.value)}
                        className={`my-1 align-self-center form-control ${statusMode ? `${style.calculator_border_color_dark} ${style.calculator_text_dark_mode} ${style.calculator_bg_dark}` : ""}`}
                    />
                </div>
            )}
        </div>
    );
}
export {
  EditableMarket as default
};